import * as React from 'react'
import { Col, Row } from 'react-bootstrap'
import styled from 'styled-components'
import { media } from '../../../utils'

const NumberFormat = require('react-number-format')

interface PriceHeadlineProps {
  border?: string
  service: string
  price?: number | string | JSX.Element
  id?: string
  icon?: any
}

export const PriceHeadline = (props: PriceHeadlineProps) => {
  const { border, price, service, id, icon } = props

  const renderPrice = () => {
    if (price !== undefined) {
      if (price === '0' || price === 0) return 'Inkl.'
      return (
        <NumberFormat
          value={price || ''}
          displayType='text'
          thousandSeparator='.'
          decimalSeparator=','
          prefix='€ '
          decimalScale={2}
          fixedDecimalScale={!Number.isInteger(+price)}
        />
      )
    }
    return ''
  }

  let descriptionWidth = 12
  if (icon) descriptionWidth -= 2
  if (price !== undefined) descriptionWidth -= 3

  return (
    <div style={{ width: '100%' }}>
      <PriceHeadlineWrapper border={border}>
        <Row>
          {!!icon && (
            <Col xs={2} sm={1}>
              <img src={icon} alt='O' />
            </Col>
          )}
          <Col xs={descriptionWidth} style={{ paddingRight: '7px' }}>
            <ServiceHeadline id={id}>{service}</ServiceHeadline>
          </Col>
          <Col xs={3} sm={icon ? 4 : 3}>
            <Price>{renderPrice()}</Price>
          </Col>
        </Row>
      </PriceHeadlineWrapper>
    </div>
  )
}

const ServiceHeadline = styled.p`
  font-size: 18px;
  font-weight: 700;
  display: inline;
  margin: 0px;
  vertical-align: middle;
  ${media.tablet` font-size: 16px; `}
`

const Price = styled.p`
  display: inline;
  float: right;
  font-size: 18px;
  font-weight: 700;
  color: #4a4a4a;
  overflow: hidden;
  white-space: nowrap;
  ${media.tablet` font-size: 16px; `}
`

const PriceHeadlineWrapper = styled.div`
  padding-bottom: 10px;
  padding-top: 10px;
  border-bottom: ${(props) => props.border}
  margin-bottom: 20px;

  img {
    width: 30px;
    margin-right: 15px;
    margin-left: 7.5px;
  }

  ${media.phone`
    padding-bottom: 5px;
    padding-top: 5px;
  `}
`
PriceHeadlineWrapper.defaultProps = {
  border: '1.5px solid #677d7f'
}

export default PriceHeadline



// WEBPACK FOOTER //
// ./src/components/atoms/configurator/PriceHeadline.tsx